import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages, { loadLanguage } from './local/index';
import { setFateuniLanguageCookie } from '@/utils/languageCookie';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'zh-TW',
    supportedLngs: ['zh-TW', 'zh-CN', 'en', 'ja', 'ko'],
    load: 'currentOnly',
    detection: {
      // 优先使用用户上次选择的语言（localStorage），其次 fateuniLanguage cookie，最后浏览器语言
      order: ['localStorage', 'cookie', 'navigator'],
      lookupLocalStorage: 'fateuniLanguage',
      lookupCookie: 'fateuniLanguage',
      caches: ['localStorage', 'cookie'],
    },
    defaultNS: 'common',
    ns: [
      'common', 'home', 'paipan', 'tarotDetail', 'zodiacDetail',
      'zhouyiDetail', 'astroDice', 'guaqian', 'lingbai', 'shicao', 'liuyao',
      'share', 'consent', 'profile', 'profileManage',
    ],
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

// 初始写入 fateuniLanguage cookie（detector 已解析出初始语言；后端拦截器/resolveLang 消费）
setFateuniLanguageCookie(i18n.language);

// 检测初始语言可能与随后的用户切换产生竞争：nextRequested 始终指向用户最新意图。
// 按需加载对应翻译包（zh-TW 已同步进首屏，无需加载），加载完成后重放 changeLanguage，
// 确保组件在资源就绪后用新语言重渲染。
let loadingLang: string | null = null;
let nextRequested: string | null = null;

const ensureLanguageLoaded = (lng: string): void => {
  if (lng === 'zh-TW' || loadingLang === lng) return;
  if (messages[lng]) return;
  loadingLang = lng;
  nextRequested = lng;
  loadLanguage(lng)
    .then(() => {
      loadingLang = null;
      if (nextRequested !== lng) return;
      i18n.changeLanguage(lng);
    })
    .catch(() => {
      loadingLang = null;
    });
};

const persistLanguage = (lng: string): void => {
  try {
    localStorage.setItem('fateuniLanguage', lng);
  } catch {
    // localStorage 不可用时忽略
  }
  setFateuniLanguageCookie(lng);
};

i18n.on('languageChanged', (lng: string) => {
  persistLanguage(lng);
  ensureLanguageLoaded(lng);
});

// detector 在 init() 内部已触发首次 languageChanged，监听器挂在 init 之后的，需手动补一次加载
persistLanguage(i18n.language);
ensureLanguageLoaded(i18n.language);

export default i18n;